export default "__VITE_ASSET__B5hA2JJZ__"